"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const card_container_styles_1 = require("./card-container.styles");
const CardContainer = ({ children }) => {
    return react_1.default.createElement(card_container_styles_1.Card, null, children);
};
exports.default = CardContainer;
//# sourceMappingURL=card-container.js.map